import { render, staticRenderFns } from "./akcd_codes.vue?vue&type=template&id=965c3364&scoped=true"
import script from "./akcd_codes.vue?vue&type=script&lang=js"
export * from "./akcd_codes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965c3364",
  null
  
)

export default component.exports